define('commons/contract-info-timeline',['jquery', 'timeline'],  function($, Timeline) {

    // Contract timeline
    var ContractInfoTimeline = function(container, contracts, options) {
        var settings = {
            'onSelectItem': undefined,
            'tooltip': false
        };
        // Call the inherited timeline constructor
        Timeline.call(this, $(container).get(0));
        this.addItemType('contract', ContractInfoTimeline.ItemContract);
        // Extends options
        $.extend(this.options, settings, options);
        this.draw(contracts, {
            width: '100%',
            editable: false,
            animate: false,
            eventMargin: 10,
            eventMarginAxis: 10,
            showMajorLabels: true,
            showCustomTime: false,
            showNavigation: false,
            cluster: false,
            axisOnTop: true,
            snapEvents: false,
            dragAreaWidth: 20,
            style: 'contract',
            onSelectItem: this.goToItem
        });

    };

    // Inherit from timeline
    for ( var element in Timeline.prototype) {
        ContractInfoTimeline.prototype[element] = Timeline.prototype[element];
    }

    ContractInfoTimeline.prototype.goToItem = function(item) {
        location.href = item.url;
    };

    /**
     * @OVERRIDE
     */
    ContractInfoTimeline.prototype.calcGroupSize = function() {
        var resized = false, i, iMax, item, finalItems, group, groups = this.groups, size = this.size, options = this.options, renderedItems = this.renderedItems;
        // loop through all groups to get the height of each group, and the
        // total height
        actualHeight = size.axis.height + 2 * options.eventMarginAxis;
        for (i = 0, iMax = groups.length; i < iMax; i++) {
            group = groups[i];
            finalItems = this.items;
            var itemsGroup = [];
            for (j = 0; j < finalItems.length; j++) {
                item = finalItems[j];
                if (item) {
                    if (item.group == group) {
                        itemsGroup.push(item);
                    }
                }
            }
            var shift = this.calculateShift(itemsGroup, 0) || 1;
            var groupHeight = Math.max(group.labelHeight || 0, group.itemsHeight || 0);
            resized = resized || (groupHeight != group.height);
            group.height = ((groupHeight + options.eventMargin) * shift);

            actualHeight += groups[i].height + options.eventMargin;
        }

        // calculate top positions of the group labels and lines
        var eventMargin = options.eventMargin, top = options.axisOnTop ? options.eventMarginAxis + eventMargin / 2 : size.contentHeight -
                options.eventMarginAxis + eventMargin / 2, axisHeight = size.axis.height;

        for (i = 0, iMax = groups.length; i < iMax; i++) {
            group = groups[i];
            if (options.axisOnTop) {
                group.top = top + axisHeight;
                group.labelTop = top + axisHeight + (group.height - group.labelHeight) / 2;
                group.lineTop = top + axisHeight + group.height + eventMargin / 2;
                top += group.height + eventMargin;
            } else {
                top -= group.height + eventMargin;
                group.top = top;
                group.labelTop = top + (group.height - group.labelHeight) / 2;
                group.lineTop = top - eventMargin / 2;
            }
        }

        // calculate top position of the visible items
        for (i = 0, iMax = renderedItems.length; i < iMax; i++) {
            item = renderedItems[i];
            group = item.group;

            if (group) {
                item.top = group.top;
            }
        }

        resized = true;
        if (actualHeight < options.minHeight) {
            actualHeight = options.minHeight;
        }
        resized = resized || (actualHeight != size.actualHeight);
        size.actualHeight = actualHeight;

        return resized;
    };

    /**
     * Repaint all components of the Timeline
     * 
     * @return {boolean} needsReflow Returns true if the DOM is changed such that a reflow is needed.
     */
    ContractInfoTimeline.prototype.repaint = function() {
        this.calcGroupSize();
        var frameNeedsReflow = this.repaintFrame();
        var axisNeedsReflow = this.repaintAxis();
        var groupsNeedsReflow = this.repaintGroups();
        var itemsNeedsReflow = this.repaintItems();
        this.repaintCurrentTime();
        this.repaintCustomTime();
        return (frameNeedsReflow || axisNeedsReflow || groupsNeedsReflow || itemsNeedsReflow);
    };

    ContractInfoTimeline.prototype.calculateShift = function(items, shift) {
        for (var k = 0; k < items.length; k++) {
            var contract = items[k];
            if (this.overlaps(contract, items)) {
                contract.overlap = shift;
                shift++;
            }
        }
        return shift;
    };

    ContractInfoTimeline.prototype.overlaps = function(item, items) {
        for (var l = 0; l < items.length; l++) {
            var other = items[l];
            if ((item.end > other.start && item.start < other.start) || (other.end > item.start && other.start < item.start)) {
                return true;
            }
        }
        return false;
    };

    /**
     * Create an item object, containing all needed parameters
     * 
     * @param {Object}
     *            itemData Object containing parameters start, end content, group.
     * @return {Object} item
     */
    ContractInfoTimeline.prototype.createItem = function(itemData) {
        var type = '';
        if (this.options.style == 'contract') {
            type = this.options.style;
        } else {
            type = itemData.type || (itemData.activationEndTime ? 'range' : this.options.style);
        }
        var classes = ['', 'item-pricing-model-v1', 'item-pricing-model-v2'];
        var defaultClass = 'item-pricing-model-default';
        var data = {
            start: new Date(itemData.startTime),
            end: new Date(itemData.activationEndTime),
            content: itemData.name,
            className: itemData.pricingModel !=null ? classes[itemData.pricingModel] : defaultClass,
            group: this.getGroup(itemData.groupName),
            type: type,
            id: itemData.id,
            url: itemData.url,
            groupId: itemData.groupId,
            pricingModel: itemData.pricingModel,
    
        };
        var initialTop, options = this.options;
        if (options.axisOnTop) {
            initialTop = this.size.axis.height + options.eventMarginAxis + options.eventMargin / 2;
        } else {
            initialTop = this.size.contentHeight - options.eventMarginAxis - options.eventMargin / 2;
        }

        if (type in this.itemTypes) {
            return new this.itemTypes[type](this, data, {
                'top': initialTop
            });
        }

        console.log('ERROR: Unknown event style "' + type + '"');
        return new Timeline.Item(this, data, {
            'top': initialTop
        });
    };

    ContractInfoTimeline.prototype.clean = function() {
        // reposition all visible items
        this.renderedItems.forEach(function (item) {
            $(item.dom).off('.contractinfotimeline');
        });
        links.events.removeAllListeners();
        $('.timeline-event').tooltip('destroy');
        this.deleteAllItems()
    }

    /**
     * New Item style
     */

    /**
     * @constructor ContractInfoTimeline.ItemContract
     * @param {Object}
     *            timeline Object containing all contract parameters.
     * @param {Object}
     *            data Object containing all contract parameters.
     * @param {Object}
     *            [options] Options to set initial property values {Number} top {Number} left {Number} width {Number} height
     */
    ContractInfoTimeline.ItemContract = function(timeline, data, options) {
        Timeline.ItemRange.call(this, data, options);
        if (data) {
            this.id = data.id;
            this.url = data.url;
            this.groupId = data.groupId;
            this.next = data.next;
            this.pricingModel = data.pricingModel;
        }
        this.pricingModels = ['', 'V1', 'V2'];
        this.prefix = '';
        this.timeline = timeline;
        this.overlap = 0;
    };

    // Inherit from ContractInfoTimeline.RangeItem
    for ( var elt in Timeline.ItemRange.prototype) {
        ContractInfoTimeline.ItemContract.prototype[elt] = Timeline.ItemRange.prototype[elt];
    }

    /**
     * @OVERRIDE
     */
    /**
     * Creates the DOM for the item, depending on its type
     * 
     * @return {Element | undefined}
     * @override
     */
    ContractInfoTimeline.ItemContract.prototype.createDOM = function() {
        // background box
        var divBox = $('<div/>');
        divBox.css('position', 'absolute');
        // contents box
        var divContent = $('<div/>').appendTo(divBox);
        divContent.addClass('timeline-event-content');
        if (this.next) {
            var span = $('<span/>').appendTo(divBox);
            span.addClass('icon-link right');
        }
        this.dom = divBox.get()[0];
        this.updateDOM();
        // Set tooltip
        if (this.timeline.options.tooltip) {
            var offsetStart = this.start.toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
            var offsetEnd = this.end.toString().match(/([A-Z]+[\+-][0-9]+)/)[1];
            var startFormated = $.datepicker.formatDate('yy-mm-dd', this.start) + ' ' + $.datepicker.formatTime('HH:mm', {
                hour: this.start.getHours(),
                minute: this.start.getMinutes()
            });
            var endFormated = $.datepicker.formatDate('yy-mm-dd', this.end) + ' ' + $.datepicker.formatTime('HH:mm', {
                hour: this.end.getHours(),
                minute: this.end.getMinutes()
            });
            var tipHtml = '<div class="help-tip-title">' + this.content + '</div>' + '<div class="help-tip-content"><p>' + 'Start date : ' +
                    startFormated + ' ' + offsetStart + '<br/>' + 'End date : ' + endFormated + ' ' + offsetEnd + '<br/>' + '<br/>' +
                    'Pricing model : ' + (this.pricingModel != null ? this.pricingModels[this.pricingModel] : 'N/A')  + '<br/>' +
                    '<br/>' + '</p></div>';
            divBox.tooltip({
                items: divBox,
                track: true,
                tooltipClass: 'help-ui-tooltip',
                content: tipHtml
            });
        }
        return divBox.get()[0];
    };

    /**
     * Update the DOM of the item. This will update the content and the classes of the item
     * 
     * @override
     */
    ContractInfoTimeline.ItemContract.prototype.updateDOM = function() {
        var divBox = this.dom;
        if (divBox) {
            // update contents
            divBox.firstChild.innerHTML = this.prefix + ' ' + this.content;

            // update class
            divBox.className = 'timeline-event timeline-event-range ui-widget ui-state-default rounded';

            if (this.isCluster) {
                Timeline.addClassName(divBox, 'timeline-event-cluster ui-widget-header');
            }

            // add item specific class name when provided
            if (this.className) {
                Timeline.addClassName(divBox, this.className);
            }

            // TODO: apply selected className?
        }
    };

    /**
     * Select the item
     * 
     * @override
     */
    ContractInfoTimeline.ItemContract.prototype.select = function() {
        var dom = this.dom;
        if (this.timeline.options.onSelectItem)
            this.timeline.options.onSelectItem.call(this, this);
        ContractInfoTimeline.addClassName(dom, 'timeline-event-selected ui-state-active');
    };

    /**
     * Reposition the item, recalculate its left, top, and width, using the current range of the timeline and the timeline options. *
     * 
     * @param {Timeline}
     *            timeline
     * @override
     */
    ContractInfoTimeline.ItemContract.prototype.updatePosition = function(timeline) {
        var dom = this.dom;
        if (dom) {
            var contentWidth = timeline.size.contentWidth, left = timeline.timeToScreen(this.start), right = timeline.timeToScreen(this.end);

            // limit the width of the this, as browsers cannot draw very wide divs
            if (left < -contentWidth) {
                left = -contentWidth;
            }
            if (right > 2 * contentWidth) {
                right = 2 * contentWidth;
            }

            dom.style.top = this.top + (this.overlap * (this.height + timeline.options.eventMargin)) + 'px';

            dom.style.left = left + 'px';
            dom.style.width = Math.max(right - left, 1) + 'px';
            var self = this;
            $(dom).on('mouseenter.contractinfotimeline', function() {
                var linkedContract = self.getLinked();
                if (linkedContract.length > 1) {
                    // Ordonnate linked contract
                    ContractUtils.ordonnateContracts(linkedContract, 1);
                    var notLinked = [];
                    notLinked = $.grep(self.timeline.items, function(item) {
                        return $.inArray(item, linkedContract) < 0;
                    });
                    $.each(notLinked, function(index, item) {
                        $(item.dom).addClass('notlinked');
                    });
                }
            }).on('mouseleave.contractinfotimeline', function() {
                var linkedContract = self.getLinked();
                if (linkedContract.length > 1) {
                    var notLinked = [];
                    notLinked = $.grep(self.timeline.items, function(item) {
                        return $.inArray(item, linkedContract) < 0;
                    });
                    $.each(notLinked, function(index, item) {
                        $(item.dom).removeClass('notlinked');
                    });
                    $.each(linkedContract, function(index, item) {
                        item.prefix = '';
                        item.updateDOM();
                    });
                }
            });
        }
    };
    ContractInfoTimeline.ItemContract.prototype.getLinked = function() {
        var linkedContract = [];
            var stack = [];
            stack = $.extend(stack, this.timeline.items);
            linkedContract.push(this);
            stack.splice($.inArray(this, stack), 1);
            ContractUtils.findLinked(stack, linkedContract, this);
        
        return linkedContract;
    };

    var ContractUtils = function() {
    };

    ContractUtils.findLinked = function(stack, linkedContract, item) {
        $.each(stack, function(index, current) {
            if (current) {
                if (item != current && ((item.next && item.next == current.id) || (current.next && current.next == item.id))) {
                    linkedContract.push(current);
                    var subStack = [];
                    subStack = $.extend(subStack, stack);
                    subStack.splice($.inArray(current, subStack), 1);
                    ContractUtils.findLinked(subStack, linkedContract, current);
                }
            }
        });
    };

    ContractUtils.ordonnateContracts = function(contracts, index) {
        var item = ContractUtils.getContractStartMin(contracts);
        var subStack = [];
        subStack = $.extend(subStack, contracts);
        $.each(contracts, function(i, current) {
            if (item.next == current.next) {
                current.prefix = index + ' - ';
                current.updateDOM();
                subStack.splice($.inArray(current, subStack), 1);
            }
        });
        if (subStack.length > 0) {
            ContractUtils.ordonnateContracts(subStack, index + 1);
        }
    };

    ContractUtils.getContractStartMin = function(contracts) {
        // find contract whith start minimum
        var startArray = contracts.map(function(contract) {
            return contract.start;
        });
        var startMin = Math.min.apply(null, startArray);
        var contractMin;
        $.each(contracts, function(index, current) {
            if (current.start.getTime() == startMin) {
                contractMin = current;
            }
        });
        return contractMin;
    };
    
    return ContractInfoTimeline;
});
